import React from "react";
import './index.scss'
import DatePicker from "sassy-datepicker";

export default ({action}) => {
  return (
    <DatePicker onChange={action} />
  )
}
